module.exports = __webpack_public_path__ + "static/IPhone_App_Wizard_09-4ee8f829068382c050c61c9e1e768a3e.png";